/**
 * Lemon Squeezy overlay checkout for the ISO 27001 Document Pack (one-time).
 * Anyone can buy without an account. After purchase, the buyer receives
 * an email instructing them to create an account with the same email to
 * unlock their downloads (handle_new_user trigger auto-links the order).
 */

import { useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';

const LS_DOC_PACK_URL = 'https://iso-27001-kit.lemonsqueezy.com/checkout/buy/86f09696-4a7e-426c-83d1-567ac7f0abdc';

type LemonWindow = Window & {
  LemonSqueezy?: { Url: { Open: (u: string) => void } };
};

interface DocPackCheckoutProps {
  open: boolean;
  onClose: () => void;
}

export function DocPackCheckout({ open, onClose }: DocPackCheckoutProps) {
  const { user, loading } = useAuth();

  useEffect(() => {
    if (!open || loading) return;

    // Prefill email if signed in, otherwise let buyer enter any email at checkout.
    const finalUrl = user?.email
      ? `${LS_DOC_PACK_URL}?checkout[email]=${encodeURIComponent(user.email)}`
      : LS_DOC_PACK_URL;

    if (typeof window !== 'undefined' && (window as LemonWindow).LemonSqueezy) {
      (window as LemonWindow).LemonSqueezy!.Url.Open(finalUrl);
    } else {
      window.open(finalUrl, '_blank');
    }
    onClose();
  }, [open, loading, user, onClose]);

  return null;
}
